import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function Clients() {
  const clients = [
    { name: 'Omar Abdullah', role: 'Political Leader' },
    { name: 'Naveen Jindal', role: 'Business Magnate' },
    { name: 'Abhay Deol', role: 'Actor & Producer' },
    { name: 'Rani Mukherjee', role: 'Actress' },
    { name: 'Dr. Naresh Trehan', role: 'Cardiovascular Surgeon' },
    { name: 'Atul Punj', role: 'Industrialist' },
    { name: 'Nikhil Nanda', role: 'Business Executive' },
    { name: 'Shweta Nanda', role: 'Author & Columnist' },
    { name: 'Priya Paul', role: 'Hotelier' },
    { name: 'Pia Singh', role: 'Entrepreneur' },
    { name: 'Samir Jain', role: 'Media Executive' },
    { name: 'Shobana Bhartia', role: 'Media Chairperson' },
    { name: 'Abu Jani', role: 'Fashion Designer' },
    { name: 'Dimple Poddar', role: 'Socialite' },
    { name: 'Kalil Puri', role: 'Business Leader' },
    { name: 'Omkar Kanwar', role: 'Industrialist' },
    { name: 'Kavita Singh', role: 'Art Patron' },
    { name: 'Sunjay Kapoor', role: 'Entrepreneur' },
    { name: 'Sajjan Jindal', role: 'Chairman, JSW Group' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header darkMode />
      
      <section className="pt-32 pb-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">Elite Clients</h1>
            <div className="w-24 h-1 bg-[#C9A961] mx-auto mb-6"></div>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Trusted by distinguished leaders, innovators, and visionaries across industries
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {clients.map((client, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 group hover:-translate-y-2 border border-gray-100"
              >
                <div className="flex items-center mb-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#C9A961] to-[#B89851] rounded-full flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <span className="text-2xl font-bold text-white">
                      {client.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-bold text-gray-900">{client.name}</h3>
                    <p className="text-sm text-gray-500">{client.role}</p>
                  </div>
                </div>
                <div className="pt-4 border-t border-gray-100">
                  <div className="flex items-center text-[#C9A961]">
                    <i className="ri-star-fill text-sm"></i>
                    <i className="ri-star-fill text-sm ml-1"></i>
                    <i className="ri-star-fill text-sm ml-1"></i>
                    <i className="ri-star-fill text-sm ml-1"></i>
                    <i className="ri-star-fill text-sm ml-1"></i>
                    <span className="ml-2 text-sm text-gray-600">Premium Client</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}